<template>
  <vue-modal
    :name="name"
    :max-width="isPortrait ? 400 : 650"
    height="auto"
    scrollable
    :adaptive="true"
    :click-to-close="false"
  >
    <div style="position:relative; width:100%">
      <div class="img-container">
        <img ref="img">
      </div>
      <div class="controls up-controls">
        <span class="crop-title">{{ adminText('shared.cropImage', 'Crop image') }}</span>
      </div>
      <div class="controls down-controls">
        <main-button depressed :text="adminText('shared.save', 'Save')" @click.prevent="onSave" />
        <main-button
          :text="adminText('shared.cancel', 'Cancel')"
          flat
          color="white"
          @click.prevent="onCancel"
        />
      </div>
    </div>
  </vue-modal>
</template>

<script>
import AdminContext from '@/admin-i18n/context'


import Cropper from 'cropperjs'
import Vue from 'vue'

export default {
  mixins: [AdminContext],
  name:'cropper',
  props: {
    aspectRatio: Number,
    image: String,
    isPortrait: Boolean,
    name: String,
  },
  data(){
    return {
      cropper: null,
      cropperInit: false,
    }
  },
  watch: {
    async image(value) {
      this.$modal.show(this.name)
      await Vue.nextTick()
      if(value && this.$refs.img) {
        this.$refs.img.width = '400px'
        this.cropper = new Cropper(this.$refs.img, {
          viewMode: 1,
          movable: true,
          zoomable: false,
          rotatable: false,
          scalable: true,
          aspectRatio: this.aspectRatio,
        })
        await Vue.nextTick()
        this.cropper.replace(value)
        await Vue.nextTick()
      }
      else {
        this.$modal.hide(this.name)
      }
    },
  },
  async mounted () {
    this.$modal.show(this.name)
    await Vue.nextTick()
    this.$modal.hide(this.name)
    await Vue.nextTick()
  },
  methods: {
    async onSave() {
      const img = this.cropper.getCroppedCanvas().toDataURL()
      this.cropper.destroy()
      this.$emit('cropped', img)
      this.$modal.hide(this.name)
    },
    onCancel() {
      this.cropper=undefined
      this.$modal.hide(this.name)
      this.$emit('dismissed')
    },
  },
}
</script>

<style>

.v--modal {
  border-radius: 8px;
}

.crop-title {
  height: 24px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  color: white;
}
.controls {
  position: absolute;
  width:100%;
  pointer-events: none;
}

.controls > * {
  pointer-events: auto;
}

.up-controls {
  padding: 24px;
  top:0;
  background-image: linear-gradient(to bottom, rgba(33, 33, 33, 0.43), rgba(33, 33, 33, 0)) !important;
}

.down-controls {
  bottom: 0px;
  padding: 12px 0px 12px 24px;
  background-image: linear-gradient(to top, rgba(33, 33, 33, 0.43), rgba(33, 33, 33, 0)) !important;

}

.img-container {
  max-width: 100%;
}

.img-container img {
  width: 100%;
  /* height: 100%; */
}


</style>
